/* eslint-disable no-restricted-imports -- Icon package is the only allowed @fortawesome entry point (see eslint.config.mjs). */
import React, { MouseEventHandler } from 'react';
import { clsx } from 'clsx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { Colors, ColorsType } from '@common/tokens';
import { IconOfKind as InternalOfKind, getIcon } from './_icon-service';
import { Tooltip } from 'antd';

export type { AvailableIcons } from './_icon-service';
export type IconOfKind = InternalOfKind;

type Props = InternalOfKind & {
  color?: ColorsType;
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | 'xxl';
  className?: string;
  onMouseEnter?: MouseEventHandler;
  onMouseLeave?: MouseEventHandler;
  tooltipText?: string;
  fit?: boolean;
};

const SIZES = {
  xs: '8px',
  sm: '12px',
  md: '16px',
  lg: '20px',
  xl: '24px',
  xxl: '56px',
};

export function Icon({
  size = 'md',
  className,
  color,
  onMouseEnter,
  onMouseLeave,
  tooltipText,
  fit,
  ...props
}: Props) {
  const faIcon = getIcon(props);
  const colorCode = Colors[color!];

  const glyph = (
    <FontAwesomeIcon
      icon={faIcon}
      color={colorCode}
      style={{ color: colorCode, fontSize: SIZES[size] }}
      className={clsx('wk-icon', className, fit && 'wk-icon--fit')}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    />
  );

  return (
    <>
      {tooltipText ? (
        <Tooltip title={tooltipText} mouseEnterDelay={0.2}>
          {glyph}
        </Tooltip>
      ) : (
        glyph
      )}
      <style jsx>{`
        :global(.wk-icon.wk-icon--fit) {
          width: auto;
        }
      `}</style>
    </>
  );
}
